import { HLS, HLS_KR, SS } from '../../utils/playerConstants';
import deviceInfo from '../all/deviceInfo';


const multipleaudio = {};
// HLS
multipleaudio.hls = {};
multipleaudio.hls.vod = false;
multipleaudio.hls.live = false;
multipleaudio.hls.timeshift = false;
// HLS_KR
multipleaudio.hls_kr = {};
multipleaudio.hls_kr.vod = false;
multipleaudio.hls_kr.live = false;
multipleaudio.hls_kr.timeshift = false;
// SS
multipleaudio.smooth_streaming = {};
multipleaudio.smooth_streaming.vod = true;
multipleaudio.smooth_streaming.live = false;
multipleaudio.smooth_streaming.timeshift = false;

const supported_stream_types = {};
supported_stream_types.vod = [SS, HLS];
supported_stream_types.live = [HLS_KR];
supported_stream_types.timeshift = [HLS_KR];

export default {
  appKey: '235116c5d63d79672eb8d58a46f6a638',
  appSubkey: 'lg',
  // Request params
  device_category: 'tv',
  /* device_id:"nousar", */
  device_manufacturer: 'lg',
  device_model: 'lg',
  device_name: 'lg',
  device_type: 'TV',
  stream_type: 'smooth_streaming',
  device_so: deviceInfo.os.description || 'netcast',

  // multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // supported_stream_types: supported_stream_types,  //Estos valores ahora se toman de la llave supported_stream de METADATA
  akamai_id: 'LGSTV',
  useEpgPostals: true,
  //akamai_mfwk: 'mfwktv2lg-api.clarovideo.net'
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwktv2lg-api.clarovideo.net' : 'http://mfwktv2lg-api.clarovideo.net'
};



// WEBPACK FOOTER //
// ./src/devices/lg/config.js